var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {}, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('h4', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.$t('createsr.title')))]), _vm._v(" "), _c('div', {
    staticClass: "card-actions float-right",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('div'), _vm._v(" "), _c('a', {
    attrs: {
      "title": _vm.$t('createsr.backBtn')
    },
    on: {
      "click": _vm.showList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px",
      "float": "right",
      "margin-top": "-5px",
      "margin-right": "10px"
    },
    attrs: {
      "style": "font-size:18px; float:right; margin-top:-5px; margin-right:10px "
    }
  })])])])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('createsr.reverseAWB')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "reverseAWB",
      "placeholder": _vm.$t('createsr.reverseAWBPlaceholder')
    },
    on: {
      "change": _vm.clickOnReverseAWB
    },
    model: {
      value: (_vm.reverseAWB),
      callback: function($$v) {
        _vm.reverseAWB = $$v
      },
      expression: "reverseAWB"
    }
  })], 1), _vm._v(" "), (_vm.reverseAWB == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.reverseAWBErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('createsr.transporter')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel),
      expression: "searchchannel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchchannel"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.transporterSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('createsr.transporter')))]), _vm._v(" "), _vm._l((_vm.transporterList), function(transporter) {
    return _c('option', {
      domProps: {
        "value": transporter.couriername
      }
    }, [_vm._v(_vm._s(transporter.couriername))])
  })], 2)]), _vm._v(" "), (_vm.searchchannel == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.transporterErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('createsr.salesOrder')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "salesOrder",
      "placeholder": _vm.$t('createsr.salesOrderPlaceholder')
    },
    on: {
      "keyup": _vm.validateSalesOrder
    },
    model: {
      value: (_vm.salesOrder),
      callback: function($$v) {
        _vm.salesOrder = $$v
      },
      expression: "salesOrder"
    }
  })], 1), _vm._v(" "), (_vm.salesOrder == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.salesOrderErr))]) : _vm._e(), _vm._v(" "), (_vm.salesOrder != '' && _vm.invalidOrderErr != '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.invalidOrderErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('createsr.clientReturnId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "clientRtrnId",
      "placeholder": _vm.$t('createsr.clientReturnIdPlaceholder')
    },
    model: {
      value: (_vm.clientRtrnId),
      callback: function($$v) {
        _vm.clientRtrnId = $$v
      },
      expression: "clientRtrnId"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "serachbtn"
  }, [_c('label'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "id": "addlinebtn"
    },
    on: {
      "click": _vm.validate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('createsr.addLinesBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.reset(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])]), _vm._v(" "), (_vm.isvalidated) ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('createsr.srLineItems')))]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchSRLines
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" " + _vm._s(_vm.$t('createsr.fetchSRBtn')))])])]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isvalidated) ? _c('div', [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('createsr.srNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('createsr.productIdEAN')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('createsr.productName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('createsr.qty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('common.table.action')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.SRLineItemsListArr), function(data, index) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "25%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.productid),
        expression: "data.productid"
      }],
      staticStyle: {
        "width": "100%",
        "height": "30px",
        "text-align": "center"
      },
      attrs: {
        "placeholder": _vm.$t('createsr.productIdEANPlaceholder'),
        "name": "data.productid"
      },
      domProps: {
        "value": (data.productid)
      },
      on: {
        "keyup": function($event) {
          _vm.validateProduct(data, index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.productid = $event.target.value
        }
      }
    }), _vm._v(" "), (data.productErr != '') ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(data.productErr))]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30%"
      }
    }, [_c('span', [_vm._v(_vm._s(data.productname))])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "5%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.qnty),
        expression: "data.qnty"
      }],
      staticStyle: {
        "height": "30px",
        "text-align": "center"
      },
      attrs: {
        "type": "number",
        "min": "1",
        "placeholder": _vm.$t('createsr.qtyPlaceholder')
      },
      domProps: {
        "value": (data.qnty)
      },
      on: {
        "keyup": function($event) {
          _vm.validateqnty(data, index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.qnty = $event.target.value
        }
      }
    }), (data.isvalidateqnty == false) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(data.qtyErr))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "7%"
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      staticStyle: {
        "color": "green",
        "font-size": "15px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.check(0)
        }
      }
    }), _vm._v("      "), _c('i', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "color": "#ff0000",
        "font-size": "15px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.deleterow(data, index)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.dublicatemsg) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('createsr.productIdEANError')))])])]) : _vm._e(), _vm._v(" "), (_vm.emptyErrMsg != '') ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(this.emptyErrMsg))])])]) : _vm._e(), _vm._v(" "), (_vm.isqtycheck) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('createsr.qtyError')))])])]) : _vm._e(), _vm._v(" "), (_vm.isfetchResult) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('createsr.srError')))])])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "float": "right",
      "margin": "2px 0px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.check(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('createsr.createSRBtn')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]) : _vm._e()])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74873417", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74873417","hasScoped":true}!./src/views/components/createsalesreturn/createsalesreturn.component.html
// module id = 1610
// module chunks = 0